import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const [EmptyProvider, useEmptyContext] = buildGlobalReferenceContext("Empty");

export { EmptyProvider, useEmptyContext };
//# sourceMappingURL=context.mjs.map
